import React from 'react';
import './App.css';
import GameContainer from './Game';

function App() {
  return (
    <div className="App">
      <div id="portal-root"></div>
      <div className="game-container">
        <GameContainer />
      </div>
      <a 
        href="https://jam.pieter.com" 
        style={{
          fontFamily: 'system-ui, sans-serif',
          position: 'fixed',
          bottom: '-1px',
          right: '-1px',
          padding: '7px',
          fontSize: '14px',
          fontWeight: 'bold',
          background: '#fff',
          color: '#000',
          textDecoration: 'none',
          zIndex: 10000,
          borderTopLeftRadius: '12px',
          border: '1px solid #fff'
        }}
      >
        🕹️ Vibe Jam 2025
      </a>
    </div>
  );
}

export default App;
